// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 792) return "bundle.595062ea499e0dce94318c9039b60cfa.css";
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "15d1d26a303d7c5c291a0e586cc46d38" + ".css";
};